import { useSelector } from 'react-redux';

import {
  selectCurrentStyleCategoryId,
  selectIsTastePathProductsLoading,
  selectNextStyleCategoryId,
  selectTastePathData,
  selectTastePathDataList,
} from '@lib/tools/tastePathProducts/selectors/index';

export const useTastePathProducts = () => ({
  currentStyleCategoryId: useSelector(selectCurrentStyleCategoryId),
  isTastePathProductsLoading: useSelector(selectIsTastePathProductsLoading),
  nextStyleCategoryId: useSelector(selectNextStyleCategoryId),
  tastePathData: useSelector(selectTastePathData),
  tastePathDataList: useSelector(selectTastePathDataList),
});
